import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitButtonGroup(props) {
  var children = props.children,
    className = props.className,
    style = props.style,
    dataTestId = props['data-testid'];
  return /*#__PURE__*/_jsx("div", {
    className: classNames('btn-group', className),
    style: style,
    role: "group",
    "data-testid": dataTestId,
    children: children
  });
}
export default SplitButtonGroup;
//# sourceMappingURL=SplitButtonGroup.js.map